import React from "react";
import styled from "styled-components";
import BotAvatar from "./BotAvatar";

const ChatMessage = props => {
  let acceptedAnswers = props.acceptedAnswers;
  let { from, type, question, value, last } = props.message;
  let baseStyles = {
    display: "flex",
    flexDirection: "row",
    marginTop: 4
  };

  let isBot = from === "bot";
  let extraType = question.extra
    ? question.extra[isBot ? "questDisplay" : "answerDisplay"] || "text"
    : "text";

  return (
    <div
      style={{
        ...baseStyles,
        marginBottom: last ? 12 : 0,
        alignItems: "flex-end",
        justifyContent: isBot ? "flex-start" : "flex-end"
      }}
    >
      {isBot && <BotAvatar isLast={last} />}

      {(() => {
        switch (extraType) {
          default:
            return (
              <Bubble bot={isBot}>
                <BubbleText bot={isBot}>
                  <div dangerouslySetInnerHTML={{ __html: value }} />
                </BubbleText>
              </Bubble>
            );
        }
      })()}
    </div>
  );
};

const Bubble = styled.div`
  background-color: ${props =>
    props.bot ? "rgba(214,185,161,0.50)" : "#CCA37B"};
  border-radius: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 9px;
  max-width: 316px;

  @media screen and (max-width: 479px) {
    max-width: 259px;
  }
`;

const BubbleText = styled.p`
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 1.4px;
  color: ${props => (props.bot ? "#000" : "#fff")};

  & > a {
    outline: none;
  }
`;

export default ChatMessage;
